/*
 * @file shopClassify.js
 * @author: cdtanhongzhao
 * @describe: pc店铺店内分开js
 * @date: 2017-09-22 16:47
 */
import $ from 'jquery';
import manager from '../manager';


manager.add('getShopClassify', {
	async created(param) {
		$(this.dom).find(".J_classifyArrow").on("click", function() {
			$(this).parent().hasClass("d-item-spread") ? $(this).parent().removeClass("d-item-spread") : $(this).parent().addClass("d-item-spread");
		})
	},
	destroyed() {
		$(this.dom).find(".J_classifyArrow").off("click");
	}
})
